// Angular
import { Component, OnInit } from "@angular/core";
// Models
// import { Post } from './../../models/post';
// External
import {
  AngularFireDatabase,
  FirebaseListObservable,
} from "angularfire2/database";
import * as lodash from "lodash";
import { Offer } from "./../../models/offer";
import { DatePipe } from "@angular/common";
import { ApiService } from "./../../services/api";
import { OrderPipe } from "ngx-order-pipe";
import { OAuthService } from "./../../services/o-auth";
import * as moment from 'moment';
@Component({
  templateUrl: "./events.component.html",
  styles: [`.reset{
    margin-top: 27px !important;
  }`]
})
export class EventsComponent implements OnInit {
  public offers: Array<any> = [];

  public imageLoader = true;
  public filterargs: Offer;
  public date: any;
  public allData: any;
  public selectAll: boolean;
  public allOffers: Array<any> = [];
  public tabIndex: number;
  private offsetOffers: number;
  public order = "offerName";
  public reverse = true;
  subscription: any;
  public user: any;
  public offerTypeFilter: number = 0;
  public offerStatusFilter: number = 0;
  public allOfferTypeFilter: number = 0;
  public allOfferStatusFilter: number = 0;
  constructor(
    private fireDatabase: AngularFireDatabase,
    private datePipe: DatePipe,
    private oAuthService: OAuthService,
    private apiService: ApiService,
    private orderPipe: OrderPipe
  ) {
    this.filterargs = new Offer();
    this.selectAll = false;

    this.offsetOffers = 15;
  }
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }
  ngOnInit() {
    this.user = this.oAuthService.getClub();
    this.initOffersList(0, 0, null);
  }
  public dateChange(event) {
    this.initOffersList(
      this.offerTypeFilter,
      this.offerStatusFilter,
      this.date
    );
  }

  resetEventFilter(event)
  {
    this.offerTypeFilter = 0
    this.offerStatusFilter = 0;
    this.date = undefined;
    this.initOffersList(0, 0, null);
  }

  resetAllEventFilter(event)
  {
    this.offerTypeFilter = 0;
    this.offerStatusFilter = 0;
    this.allData = undefined;
    this.getAllOffers(
      this.offerTypeFilter,
      this.offerStatusFilter,
      this.allData
    );
  }

  allDateChange(event) {
    this.getAllOffers(
      this.offerTypeFilter,
      this.offerStatusFilter,
      this.allData
    );
  }

  offerTypeFilterChange(event) {
    this.initOffersList(event, this.offerStatusFilter, this.date);
  }

  allOfferTypeFilterChange(event) {
    this.getAllOffers(event, this.allOfferStatusFilter, this.allData);
  }
  public offerStatusFilterChange(event) {
    this.initOffersList(this.offerTypeFilter, event, this.date);
  }

  public allOfferStatusFilterChange(event) {
    this.getAllOffers(this.allOfferTypeFilter, event, this.allData);
  }

  initOffersList(offerType, offerStatus, validFrom) {
    this.selectAll = false;

    this.offers = [];
    let cid = this.user.cid ? this.user.cid : this.user.uid;
    console.log(cid);

    this.apiService.object(`/user-offers/${cid}`).then((result) => {
      if (result) {
        lodash.forEach(result, (item, key) => {
          if (item) {
            item.key = key;
            item.isSelected = false;
            item.isStockUnlimited = item.isStockUnlimited ? true : false;

            if (item.offerType == 3) this.offers.push(item);
          }
        });
        this.offers.sort(($0, $1) => {
          return $1.creationDate - $0.creationDate;
        });
        if (offerType != 0)
          this.offers = this.offers.filter((x) => x.offerType == offerType);
        if (offerStatus != 0)
          this.offers = this.offers.filter((x) => x.status == offerStatus);
        if (validFrom) {
          this.offers = this.offers.filter(
            (x) =>
            {
              if (x.eventDate)
              {
                let temp1 = new Date(x.eventDate).toDateString()
                let temp2 = new Date(validFrom).toDateString()
                return temp1 == temp2

              } else return false
              
              }
          );
        }
      }
    });
    this.imageLoader = false;
  }
  isSelect() {
    let temp = false;
    this.offers.map((o) => {
      if (o.isSelected) temp = true;
    });
    return temp;
  }
  public offerSelect(event, offer) {
    if (event) {
      offer.isSelected = true;
      var i = -1;
      for (i = 0; i < this.offers.length; i++) {
        if (this.offers[i].isSelected == false) {
          break;
        }
      }
      if (i != -1 && i != this.offers.length) {
        this.selectAll = false;
      } else {
        this.selectAll = true;
      }
    } else {
      offer.isSelected = false;
      this.selectAll = false;
    }
  }
  public selectAllOffer(event) {
    if (event) {
      lodash.forEach(this.offers, (item, key) => {
        item.isSelected = true;
      });
    } else {
      lodash.forEach(this.offers, (item, key) => {
        item.isSelected = false;
      });
    }
  }
  public activateAll() {
    let i = this.offers.findIndex((x) => x.isSelected == true);
    if (i != -1) {
      if (confirm("Are you sure,you want to Activate all selected offers?")) {
        lodash.forEach(this.offers, (item, key) => {
          if (item.isSelected && item.status == 2) {

            this.apiService
              .set(`/user-offers/${item.club.cid}/${item.key}/status`, 1)
              .then(() => {
                location.reload();
              })
              .catch((error) => {
                console.error(error);
              });
          }
        });
      }
    } else {
      alert("Select At least one voucher");
    }
  }
  public deactivateAll() {
    let i = this.offers.findIndex((x) => x.isSelected == true);
    if (i != -1) {
      if (confirm("Are you sure,you want to Deactivate all selected offers?")) {
        lodash.forEach(this.offers, (item, key) => {
          console.log(item);
          if (item.isSelected && item.status == 1) {

            this.apiService
              .set(`/user-offers/${item.club.cid}/${item.key}/status`, 2)
              .then(() => {
                location.reload();
              })
              .catch((error) => {
                console.error(error);
              });
          }
        });
      }
    } else {
      alert("Select At least one voucher");
    }
  }
  public suspendAll() {
    let i = this.offers.findIndex((x) => x.isSelected == true);
    if (i != -1) {
      if (confirm("Are you sure,you want to Suspend all offers?")) {
        lodash.forEach(this.offers, (item, key) => {
          if (item.isSelected && (item.status === 1 || item.status === 2)) {

            this.apiService
              .set(`/user-offers/${item.club.cid}/${item.key}/status`, 3)
              .then(() => {
                location.reload();
              })
              .catch((error) => {
                console.error(error);
              });
          }
        });
      }
    } else {
      alert("Select At least one voucher");
    }
  }
  public activate(item) {
    if (confirm("Are you sure,you want to Activate the offer?")) {
      if (item.status == 2) {
        this.apiService
          .set(`/user-offers/${item.club.cid}/${item.key}/status`, 1)
          .then(() => {
            this.initOffersList(
              this.offerTypeFilter,
              this.offerStatusFilter,
              this.date
            );
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }

  public deactivate(item) {
    if (confirm("Are you sure,you want to Deactivate the offer?")) {
      if (item.status == 1) {
        this.apiService
          .set(`/user-offers/${item.club.cid}/${item.key}/status`, 2)
          .then(() => {
            this.initOffersList(
              this.offerTypeFilter,
              this.offerStatusFilter,
              this.date
            );
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }
  public suspend(item) {
    if (confirm("Are you sure,you want to Suspend the offer?")) {
      if (item.status === 1 || item.status === 2) {
        // console.log(item)

        this.apiService
          .set(`/user-offers/${item.club.cid}/${item.key}/status`, 3)
          .then(() => {
            this.initOffersList(
              this.offerTypeFilter,
              this.offerStatusFilter,
              this.date
            );
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }

  onTabClick(event) {
    if (event == 1 && this.allOffers.length == 0) {
      this.getAllOffers(
        this.allOfferTypeFilter,
        this.allOfferStatusFilter,
        this.allData
      );
    }
  }

  getAllOffers(offerType, offerStatus, validFrom) {
    this.fireDatabase.object(`/user-offers`).subscribe((data) => {
      let autherIds = Object.keys(data);
      this.allOffers = [];
      autherIds.map((a) => {
        let offerKeys = Object.keys(data[a]);
        offerKeys.map((o) => {
          data[a][o]["key"] = o;
          data[a][o]["isSelected"] = false;
          data[a][o]["isStockUnlimited"] = data[a][o]["isStockUnlimited"]
            ? true
            : false;
          if (data[a][o].offerType == 3) this.allOffers.push(data[a][o]);
        });
      });

      this.allOffers.sort(($0, $1) => {
        return $1.creationDate - $0.creationDate;
      });
      if (offerType != 0)
        this.allOffers = this.allOffers.filter((x) => x.offerType == offerType);
      if (offerStatus != 0)
        this.allOffers = this.allOffers.filter((x) => x.status == offerStatus);
       if (validFrom) {
          this.allOffers = this.allOffers.filter(
            (x) =>
            {
              if (x.eventDate)
              {
                let temp1 = new Date(x.eventDate).toDateString()
                let temp2 = new Date(validFrom).toDateString()
                console.log(temp1, temp2)
                if (temp1 === temp2) return true
                else return false

              } else return false
              
              }
          );
        }
    });
  }
}
